<template>
  <div class="section">
    <div class="container">
      <div class="door-config" id="door-config">
        <div class="door-config__left">
          <div class="door-config__stycky">
            <div class="door-config__labels" v-if="label">
              <div class="label" v-for="icon in label" :key="icon">
                {{ icon }}
              </div>
            </div>
            <a
                href="#zoom-popup"
                class="door-config__img-container js--door-config-img-container js--popup"
                data-fancybox
                :data-download-src="selected?.picture"
            >
              <div class="door-config__img-item _pokr">
                <img
                    :src="selected?.picture"
                    class="js--door-config-img js--door-config-polotno _loaded"
                />
              </div>
            </a>
            <div class="d-none">
              <div id="zoom-popup" class="door-zoom-popup">
                <div
                    class="door-config__img-container js--door-config-img-container"
                >
                  <div class="door-config__img-item _pokr">
                    <img
                        :src="selected?.picture"
                        class="js--door-config-img js--door-config-polotno _loaded"
                    />
                  </div>
                </div>
                <div id="download_door">
                  <a download class="popup__download" :href="selected?.picture"
                  >
                    <svg class="svg-icon">
                      <use xlink:href="#lkd-doc-download"></use>
                    </svg
                    >
                  </a>
                </div>
                <button type="button" class="popup__close" data-fancybox-close>
                  <svg class="svg-icon">
                    <use xlink:href="#x"></use>
                  </svg>
                </button>
              </div>
            </div>

            <div class="door-config__new-price">
              <div class="door-config__new-price__top">
                <div class="">

                  <div class="door-config__price">
                    от <span class="js--door-config-price">{{ totalPriceSaleModel.toLocaleString() }}</span>&nbsp;{{ priceZnak }}
                  </div>

                  <div class="door-config__price-without-price" v-if="saleModel > 0">
                    СТАРАЯ ЦЕНА <span class="js--door-config-price-without-sale">{{ totalPrice.toLocaleString() }}</span>&nbsp;{{ priceZnak }}
                  </div>

                </div>

                <div class="door-btns-action justify-content-end">

                  <!-- Кнопки заказа и передаются данные из формы">-->
                  <div class="door-config__btns door-config__btns__second">

                    <div class="form-btns">
<!--                      <a-->
<!--                          data-fancybox-->
<!--                          href="#form"-->
<!--                          class="btn js&#45;&#45;popup js&#45;&#45;door-config-order-btn"-->
<!--                          @click="sendParams"-->
<!--                      >Заказать дверь</a>-->
<!--                      <a-->
<!--                          data-fancybox-->
<!--                          href="/ajax/forms/form_zamer.php"-->
<!--                          class="btn _white js&#45;&#45;popup js&#45;&#45;door-config-measuring-btn"-->
<!--                          data-type="ajax"-->
<!--                      >Заказать замер</a>-->
                      <a :href="'/ajax/forms/request-call.php?door-name='+encodeURI(name)+'&door-cover='+encodeURI(selected?.cover?.category+' '+selected?.cover?.color)"
                         class="btn"
                         data-type="ajax"
                         ref="formBtn"
                      >Заказать звонок</a>
                    </div>

                    <div class="btn-container">

                      <div class="door-config--btn door-config-basket-btn js--door-config-basket-btn"
                           style="cursor: pointer; align-items: center;"
                           @click="onClickBasket"
                           :class="{'added': inBasket}"
                      >
                        <img class="svg-icon"
                             style="width: 15%; height: 15%"
                             :src="inBasket ? '/img/svg/cart-fill.svg' : '/img/svg/cart.svg'"
                             alt="cart"
                        >
                        <div class="cart-label" style="font-size: 13px">{{ inBasket ? 'В корзине' : 'В корзину' }}</div>
                      </div>

                      <div class="door-config--btn door-config-favorite-btn js--door-config-favorite-btn"
                           style="cursor: pointer; align-items: center;"
                           @click="onClickFavorite"
                           :class="{'added': inFavorite}"
                      >
                        <img class="svg-icon"
                             style="width: 15%; height: 15%"
                             :src="inFavorite ? '/img/svg/heart-fill.svg' : '/img/svg/heart.svg'"
                             alt="heart"
                        >
                        <div class="cart-label" style="font-size: 13px">{{ inFavorite ? 'В избранном' : 'В избранное' }}</div>
                      </div>

                    </div>

                  </div>

                  <div
                      id="form"
                      class="js--door-config-form-to-form"
                      :style="readStyleForm"
                  >
                    <button
                        type="button"
                        data-fancybox-close=""
                        class="popup__close"
                        title="Close"
                    >
                      <svg class="svg-icon">
                        <use xlink:href="#x"></use>
                      </svg>
                    </button>
                    <div v-html="formResponse"></div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="door-config__right">
          <div class="door-config__stycky">
            <form action="" class="js--door-config-form">
              <the-group
                  :jsonData="readJson"
                  @loadData="loadData"
                  :json="json"
                  :mobile="mobile"
                  :opened="opened"
                  :selected="selected"
                  @closeModal="closeModal"
              ></the-group>
              <div
                  class="door-config__group door-config__custom _last"
                  :style="blockConfig"
              >
                <div v-show="!mobile" class="h3 color-green">
                  Ваша конфигурация
                </div>
                <div class="door-config__params">
                  <the-config-params
                      :jsonData="readJson"
                      :mobile="mobile"
                      :selected="selected"
                      @openModal="openModal"
                  />
                </div>
              </div>
              <div
                  id="door-custom-config"
                  class="door-config__group door-config__custom _last char_modal_mobile"
              >
                <button
                    type="button"
                    data-fancybox-close=""
                    class="popup__close"
                >
                  <svg class="svg-icon">
                    <use xlink:href="#x"></use>
                  </svg>
                </button>
                <div class="h3 color-green">Ваша конфигурация</div>
                <div class="door-config__params">
                  <the-config-params
                      :mobile="mobile"
                      :selected="selected"
                      @openModal="openModal"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {Fancybox} from "@fancyapps/ui";

const TheGroup = () => import("./TheGroup.vue");
const TheConfigParams = () => import("./TheConfigParams.vue");
import axios from "axios";
import Inputmask from "inputmask";

function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export default {
  components: {TheGroup, TheConfigParams},
  name: "TheApp",
  data() {
    return {
      selected: {},
      json: {},
      mobile: false,
      opened: {
        glass: false,
        cover: false,
        countcover: false,
        mechanism: false,
        size: false,
        handle: false,
        kreplenie_for_alumini: false
      },
      formResponse: "",
      isModalFormOpen: false,
      rate: document.querySelector('html').dataset.countryRate,
      priceZnak: document.querySelector('html').dataset.priceZnak,
      inBasket: false,
      checkBasketBtnTimeout: null,
      inFavorite: false,
      checkFavoriteBtnTimeout: null,
      saleModel: document.querySelector('.js-sale-model').value
    };
  },
  computed: {
    readJson() {
      const {height, pictureText, ...rest} = this.json;
      return {...rest, size: height ? {height} : {}};
    },
    readHandle() {
      if (this.selected?.handle?.handleName) {
        return `<span class="js--door-config-polotno-sect-text">${this.selected?.handle?.handleName}</span>
                      , цвет
                      <span class="js--door-config-polotno-text">${this.selected?.handle?.handleColor}</span>`;
      } else {
        return ``;
      }
    },
    readStyleForm() {
      return this.isModalFormOpen
          ? "display: inline-block;padding: 0;"
          : "display: none;";
    },
    blockConfig() {
      return this.mobile ? "display: block;" : "";
    },
    readUrl() {
      return window?.location?.href;
    },
    sendAjax() {
      let resString = "?";
      Object.keys(this.selected).forEach((key) => {
        switch (key) {
          case "countcover":
            resString += `countcover=${this.selected[key]?.countcover}&`;
            break;
          case "inputWidth":
            resString += `width=${this.selected?.inputWidth}&`;
            break;
          case "inputHeight":
            resString += `height=${this.selected?.inputHeight}&`;
            break;
          case "mechanism":
            resString += `mechanism=${this.selected[key]?.index}&`;
            break;
          case "cover":
            resString += `covercategory=${this.selected[key]?.category}&`;
            resString += `covercolor=${this.selected[key]?.color}&`;
            break;
          case "glass":
            resString += `glasscategory=${this.selected[key]?.category}&`;
            resString += `glasscolor=${this.selected[key]?.color}&`;
            break;
          case "handle":
            this.selected[key]?.handleName
                ? (resString += `handlename=${this.selected[key]?.handleName}&`)
                : "";
            this.selected[key]?.handleName
                ? (resString += `handlecolor=${this.selected[key]?.handleColor}&`)
                : "";
            break;
        }
      });
      resString += `name=${this.name}&`;
      resString = resString.slice(0, resString.length - 1);
      return resString;
    },
    totalPrice() {
      const S =
          (this.selected?.inputWidth * this.selected?.inputHeight) / 1000000;
      const priceCoverGlass = +this.selected?.priceCoverGlass;
      const priceHandle = +this.selected?.handle?.handlePrice || 0;
      const mechanismPrice = +this.selected?.mechanism?.price;
      const kreplenieForAluminiPrice = this.getKreplenieForAluminiPrice();
      const total = (S * priceCoverGlass + mechanismPrice + priceHandle + kreplenieForAluminiPrice) * this.rate;
      return Math.ceil(total);
    },
    totalPriceSaleModel() {
      return Math.ceil(this.totalPrice * ((100-this.saleModel)/100));
    },
  },
  watch: {
    selected: {
      handler() {
        const arr = this.json.prices;
        arr.forEach((el) => {
          if (
              el.coverImage === this.selected?.cover?.image &&
              el.glassImage === this.selected.glass.image
          ) {
            this.$set(
                this.selected,
                "picture",
                `/upload/patritions/${el.coverImage}${el.glassImage}${
                    this.selected?.handle?.handlePrice
                        ? this.selected?.handle?.handleImageCode
                        : ""
                }.png`
            );
            // this.selected.picture = `/upload/patritions/${el.coverImage}${el.glassImage}${this.selected?.handle?.handlePrice ? this.selected?.handle?.handleImageCode : 'www'}.png`;
            // this.selected.priceCoverGlass = el.price;
            this.$set(this.selected, "priceCoverGlass", el.price);
          }
        });
        this.checkBasketBtn();
        this.checkFavoriteBtn();
      },
      deep: true,
    },
  },
  methods: {
    readInfo(item) {
      console.log(item);
    },
    openModal(value, event) {
      if (this.mobile) {
        event.target.parentNode.classList.value ==
        "js--popup door-config-select"
            ? event.target.parentNode.setAttribute("data-fancybox", true)
            : "";
        Object.keys(this.opened).forEach((key) => {
          this.opened[key] = false;
        });
        this.opened[value] = true;
      }
    },
    closeModal() {
      document.querySelector(".popup__close").click();
      Object.keys(this.opened).forEach((key) => {
        this.opened[key] = false;
      });
      const btn = document.querySelectorAll(".js--popup.door-config-select");
      btn.forEach((item) => {
        if (item.dataset.fancybox) {
          item.removeAttribute("data-fancybox");
        }
      });
      this.isModalFormOpen = false;
    },
    onResize() {
      this.mobile = window.innerWidth <= 768;
    },
    async getData() {
      let params = this.code ? `?code=${this.code}` : "";
      try {
        const {data} = await axios("/ajax/objectPartitions.php" + params);
        this.json = data;
      } catch (error) {
        console.log(error);
      }
    },
    async sendParams() {
      try {
        const {data} = await axios(
            "/ajax/forms/get-partitions.php" + this.sendAjax
        );
        this.formResponse = data;
        this.isModalFormOpen = true;
        this.$nextTick(() => {
          window.App.forms.mask();
        });
      } catch (error) {
        console.log(error);
      }
    },
    // Записывание данных в обьект при выборе фильтров для отображения и дальнейшей передачи ajax
    loadData(value) {
      Object.keys(value).forEach((key) => {
        this.$set(this.selected, key, value[key]);
      });
    },
    getKreplenieForAluminiPrice() {
      let res = 0;

      let derg = 0;
      let plan = 0;

      if (this.selected.inputWidth <= 2000) {

        derg = 650;

        switch (this.selected.cover.color.toLowerCase()) {
          case "черный":
            plan = 1100;
            break;
          case "бронза":
            plan = 1600;
            break;
          case "шампань":
            plan = 1600;
            break;
          case "золото":
            plan = 1600;
            break;
          case "медный":
            plan = 1600;
            break;
        }

      } else if (this.selected.inputWidth <= 3000) {

        derg = 1000;

        switch (this.selected.cover.color.toLowerCase()) {
          case "черный":
            plan = 1100;
            break;
          case "бронза":
            plan = 1600;
            break;
          case "шампань":
            plan = 1600;
            break;
          case "золото":
            plan = 1600;
            break;
          case "медный":
            plan = 1600;
            break;
        }

      } else if (this.selected.inputWidth <= 4000) {

        derg = 1250;

        switch (this.selected.cover.color.toLowerCase()) {
          case "черный":
            plan = 1650;
            break;
          case "бронза":
            plan = 2400;
            break;
          case "шампань":
            plan = 2400;
            break;
          case "золото":
            plan = 2400;
            break;
          case "медный":
            plan = 2400;
            break;
        }

      }

      // Крепление к стене считается по формуле: Держатели 1 шт. + Декоративная планка 1 шт. (цвет декоративной планки должен соотноситься с цветом покрытия)
      if (this.selected.kreplenie_for_alumini === 'wall') {

        res = derg + plan;

        // Крепление к потолку считается о формуле: Декоративная планка 2 шт. (цвет декоративной планки должен соотноситься с цветом покрытия)
      } else if (this.selected.kreplenie_for_alumini === 'ceiling') {

        res = plan * 2;

      }

      return res;
    },
    getCartInfo(){

      let checkInfo = {
        id: this.id,
        price: numberWithSpaces(this.totalPrice),
        pict: $('.js--door-config-img-container').html()
      };

      $($('.door-config__custom').find('.door-config__params__tr')).each(function() {
        checkInfo[$(this).find('.door-config__params__th').text()] = $(this).find('.door-config__params__td').text().replaceAll(';',',');
      });
      
      checkInfo.data = JSON.stringify({
        type: 'Межкомнатная перегородка',
        name: this.name,
        steklo_section: this.selected.glass.category,
        steklo_tsvet: this.selected.glass.color,
        otdelka_section: this.selected.cover.category,
        otdelka_tsvet: this.selected.cover.color,
        kil_vo_poloten: this.selected.countcover.countcover,
        mechanism: this.selected.mechanism.index,
      });

      return checkInfo;
    },
    onClickBasket() {

      if (this.inBasket === true) {

        window.location.href = '/basket/'

      } else {

        const _this = this;

        let checkInfo = this.getCartInfo();

        $.ajax({
          method: "POST",
          url: '/ajax/cartManager.php',
          data: {'cart': checkInfo, 'action': 'add'},
        }).always(function (dataSuccess) {

          _this.checkBasketBtn();

        });

      }

    },
    checkBasketBtn(){
      
      if (this.checkBasketBtnTimeout) clearTimeout(this.checkBasketBtnTimeout)
      this.checkBasketBtnTimeout = setTimeout(() => {

        const _this = this;

        let checkInfo = _this.getCartInfo();

        $.ajax({
          method: "POST",
          url: '/ajax/cartManager.php',
          dataType: 'json',
          data: {'action': 'check-count'},
          success: function (cartInfo) {
            $('.cart .num').text(cartInfo.cartInfo !== 0 ? cartInfo.cartInfo : '');
          }
        });

        $.ajax({
          method: "POST",
          url: '/ajax/cartManager.php',
          data: {'cart': checkInfo, 'action': 'check'},
          success: function (dataSuccess) {
            _this.inBasket = dataSuccess === 'OK';
          }
        });

      }, 500);

    },
    getFavoriteInfo(){

      let checkInfo = {
        id: this.id,
        price: numberWithSpaces(this.totalPrice),
        pict: $('.js--door-config-img-container').html()
      };

      $($('.door-config__custom').find('.door-config__params__tr')).each(function() {
        checkInfo[$(this).find('.door-config__params__th').text()] = $(this).find('.door-config__params__td').text().replaceAll(';',',');
      });

      return checkInfo;
    },
    onClickFavorite() {

      const _this = this;

      let checkInfo = this.getFavoriteInfo();

      $.ajax({
        method: "POST",
        url: '/ajax/favoriteManager.php',
        data: {'cart': checkInfo, 'action': 'add'},
      }).always(function (dataSuccess) {

        _this.inFavorite = dataSuccess === 'added';

        _this.checkFavoriteBtn();

      });

    },
    checkFavoriteBtn(){

      if (this.checkFavoriteBtnTimeout) clearTimeout(this.checkFavoriteBtnTimeout)
      this.checkFavoriteBtnTimeout = setTimeout(() => {

        const _this = this;

        let checkInfo = _this.getFavoriteInfo();

        $.ajax({
          method: "POST",
          url: '/ajax/favoriteManager.php',
          dataType: 'json',
          data: {'action': 'check-count'},
          success: function (favoriteInfo) {
            $('.heart .num').text(favoriteInfo.favoriteInfo !== 0 ? favoriteInfo.favoriteInfo : '');
          }
        });

        $.ajax({
          method: "POST",
          url: '/ajax/favoriteManager.php',
          data: {'cart': checkInfo, 'action': 'check'},
          success: function (dataSuccess) {
            _this.inFavorite = dataSuccess === 'OK';
          }
        });

      }, 500);

    }
  },
  created() {
    this.getData();
    window.addEventListener("resize", this.onResize);
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {

    Fancybox.defaults = {
      ...Fancybox.defaults,
      btnTpl: {
        smallBtn:
            '<button type="button" data-fancybox-close class="popup__close" title="Close"><svg class="svg-icon"><use xlink:href="#x"></use></svg></button>',
        close:
            '<button type="button" data-fancybox-close class="popup__close" title="Close"><svg class="svg-icon"><use xlink:href="#x"></use></svg></button>',
      },
      tpl: {
        closeButton:
            '<button type="button" data-fancybox-close class="popup__close" title="Close"><svg class="svg-icon"><use xlink:href="#x"></use></svg></button>',
        closeBtn:
            '<button type="button" data-fancybox-close class="popup__close" title="Close"><svg class="svg-icon"><use xlink:href="#x"></use></svg></button>',
      },
      on: {
        done: () => {
          console.log(222);
        }
      }
    };

    $(this.$refs.formBtn).fancybox(App.popup.options);

  },
  props: {
    id: Number,
    name: String,
    code: String,
    label: [Array, String],
  },
};
</script>
<style>
/* #download_door .popup__download {
  top: 0;
} */
.door-config__labels {
  z-index: 5;
}

.fancybox-button.fancybox-close-small {
  display: none;
}

.forms-popup._wide-form.fancybox-content .fancybox-button.fancybox-close-small {
  display: block;
}

.door-zoom-popup .door-config__img-container {
  padding-bottom: 100%;
}

.fancybox-slide .door-config__img-container .door-config__img-item._pokr {
  bottom: 0;
  height: 90%;
  top: auto;
}

.js--door-config-form {
  display: grid;
}

.door-config__tab-menu {
  display: flex;
  gap: 15px;
}

.door-config__params__tr {
  cursor: auto;
}

.door-config__params__td {
  color: #362a18;
}

.door-config__group.door-config__custom._last.char_modal_mobile {
  display: none;
}

@media (max-width: 768px) {
  .door-config-select:first-child {
    border-top: none;
  }

  .door-config__group._last {
    border-top: none;
  }

  .door-config__new-price__bottom {
    display: none;
  }

  .door-config__params__tr {
    cursor: pointer;
  }

  .fancybox-container .door-config__img-container {
    margin-bottom: 30px;
  }

  .fancybox-container
  .door-config__group.door-config__custom._last.char_modal_mobile {
    display: block;
  }
}
</style>
